const tours = {
  tour: "Ekskursija", // translated 
  tours: "Ekskursijos", // translated 
  addOn: "Pridėti", // translated 
  addOns: "Priedai", // translated 
  availableEscapes: "Galimi pabėgimai", // translated 
  availableExperiences: "Galimos patirtys", // translated 
  getRequest: "Gaukite užklausą", // translated 
  sendRequest: "Išsiųsti prašmą", // translated 
  selectRoom: "Pasirinkite kambarį", // translated 
};


export default tours;
